<template>
  <div>
    <s-table
      class="profile-list no-align"
      :busy="loading"
      :items="items"
      :fields="fields"
      :filter="effectiveQuery"
      :filter-function="filterTable"
      :empty-filtered-text="$t('general.empty-list')"
    >
      <template #head(selected)>
        <div>
          <b-form-checkbox
            @click.native.stop
            v-model="all"
            @input="allChange($event)"
            >
          </b-form-checkbox>
        </div>
      </template>
      <template #cell(selected)="data">
        <b-form-checkbox
          @input="itemChanged(data.item, $event)"
          :disabled="!data.item.accessibleByCurrentUser"
          :checked="data.item.selected"
        >
        </b-form-checkbox>
      </template>
    </s-table>
  </div>
</template>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .profile-list
    max-height: 500px
    ::v-deep &__cell
      &-checkbox
        width: 2.2em
      &-id
        width: 25em
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>

<script>
import UserService from '@/domain/services/user';
import { cleanIncludes, clearDiacritics } from '@/services/stringHelper';

export default {
  props: ['query', 'user'],
  data() {
    return {
      loading: true,
      items: [],
      all: false,
      fromItemChange: false,
    };
  },
  created() {
    this.loadProfiles();
  },
  computed: {
    fields() {
      return [
        {
          key: 'selected',
          label: '',
          class: 'profile-list__cell-checkbox',
        },
        {
          key: 'name',
          label: this.$t('user-manager.editing.access-data.columns.profile'),
          class: 'profile-list__cell-name',
        },
      ];
    },
    effectiveQuery() {
      return this.query && this.query.length >= 3
        ? clearDiacritics(this.query).toLowerCase()
        : null;
    },
    hasItems() {
      return !this.loading && this.items && this.items.length;
    },
  },
  methods: {
    filterTable(profile) {
      return cleanIncludes(profile.name, this.effectiveQuery, {
        clearValueToFind: false,
      });
    },
    async loadProfiles() {
      this.loading = true;
      this.items = await UserService.getProfilesForUserEditing(this.user.id, this.user.profiles);
      this.items.sort((itemA, itemB) => {
        if (itemA.name > itemB.name) {
          return 1;
        }

        if (itemA.name < itemB.name) {
          return -1;
        }

        return 0;
      });
      this.applySelected();
      this.refreshAll();
      this.loading = false;
    },
    applySelected() {
      this.items.forEach((profile) => {
        // eslint-disable-next-line no-param-reassign
        profile.selected = this.user.profiles.includes(profile.id);
      });
    },
    isAllSelected() {
      return this.items.every(i => i.selected);
    },
    allChange(newValue) {
      if (this.fromItemChange) {
        this.fromItemChange = false;
        return;
      }

      let hasChangedItems = false;

      this.items.forEach((it) => {
        const item = it;
        if (item.selected === newValue
          || !item.accessibleByCurrentUser
        ) {
          return;
        }
        hasChangedItems = true;
        item.selected = newValue;
      });

      if (hasChangedItems) {
        this.$forceUpdate();
      }
    },
    itemChanged(eventItem, newValue) {
      const item = eventItem;
      item.selected = newValue;
      this.$forceUpdate();

      this.fromItemChange = this.refreshAll();

      this.updateUserProfilesArray();
    },
    refreshAll() {
      const allSelected = this.isAllSelected();
      if (allSelected !== this.all) {
        this.all = allSelected;
        return true;
      }
      return false;
    },
    updateUserProfilesArray() {
      this.user.profiles = this.items.filter(p => p.selected).map(p => p.id);
    },
  },
};
</script>
